<template>
  <div class="connect-2fa-popup">
    <popup :buttons="buttons" :close-action="closeModalX">
      <template v-slot:title>
        <img class="logo-image" :src="require('@/assets/lock.svg')">
        <div class="popup-title">היי דותן, מהיום התזרים שלך יכול להיות מוגן אפילו יותר!</div>
      </template>
      <template v-slot:content>
        <div class="description">
          <span>בקרוב כל חשבון רייזאפ יהיה מוגן ב־2 אמצעי אבטחה. מומלץ להוסיף כבר עכשיו! </span>
        </div>
      </template>
      <template v-slot:footer>
        <div @click="closeModal" class="mfa-button">אני אוסיף אחר כך</div>
      </template>
    </popup>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import Segment from '@/Segment';
import router from '@/router';

export default {
  name: 'Connect2faPopup',
  props: {
    closePopup: {
      type: Function,
    },
  },
  components: {
    Popup: BaseUI.Popup,
  },
  created() {
    Segment.trackUserGot('Connect2faPopupShown');
  },
  computed: {
    buttons() {
      return [
        {
          title: 'להוספת אמצעי אבטחה שני',
          action: this.redirectTo2faMigration,
          loading: false,
          size: 'slim',
        },
      ];
    },
  },
  methods: {
    closeModalX() {
      Segment.trackUserInteraction('Connect2faPopupX');
      this.closePopup();
    },
    closeModal() {
      Segment.trackUserInteraction('Connect2faPopupClose');
      this.closePopup();
    },
    async redirectTo2faMigration() {
      Segment.trackUserInteraction('Connect2faPopupRedirectToMigrate');
      await router.push({ path: '/2fa-migration' });
      this.closePopup();
    },
  },
};
</script>

<style lang="scss" scoped>

  .connect-2fa-popup {
    .popup-title {
      font-family: SimplerPro;
      font-weight: bold;
      font-size: 24px;
      line-height: 32px;
      margin-bottom: 18px;
    }

    .logo-image {
      width: 100%;
      text-align: center;
      height: 170px;
      margin: 30px 0;
    }

    .description {
      font-family: SimplerPro;
      margin-bottom: 40px;
      line-height: 26px;
      font-size: 18px;
      text-align: center;

      .bold {
        font-weight: bold;
      }
    }

    .mfa-button {
      line-height: 24px;
      font-size: 18px;
      cursor: pointer;
    }
  }
</style>
